import script from "./activate-product(s).vue?vue&type=script&setup=true&lang=js"
export * from "./activate-product(s).vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__